import { apiRequest } from '@/lib/queryClient';
import type { User } from '@/shared/schema';

const BACKEND_BASE = (import.meta as any).env.VITE_BACKEND_URL || (import.meta as any).env.VITE_API_URL || 'http://localhost:3041';

function backendUrl(path: string) {
    // ensure no double slashes
    return `${BACKEND_BASE.replace(/\/$/, '')}${path}`;
}

export async function listUsers(): Promise<User[]> {
    const url = backendUrl('/v1/users');
    console.info('[usersService] fetching users from', url);
    const res = await apiRequest('GET', url);
    const body = await res.json().catch(() => null);
    if (!body) return [];
    if (Array.isArray(body)) return body as User[];
    if (Array.isArray(body.results)) return body.results as User[];
    if (Array.isArray(body.data)) return body.data as User[];
    if (Array.isArray(body.users)) return body.users as User[];
    if (Array.isArray((body as any).docs)) return (body as any).docs as User[];
    return [];
}

export async function createUser(data: Partial<User>) {
    const res = await apiRequest('POST', backendUrl('/v1/users'), data);
    const body = await res.json().catch(() => null);
    return body;
}

export async function updateUser(id: string, data: Partial<User>) {
    const res = await apiRequest('PATCH', backendUrl(`/v1/users/${id}`), data);
    const body = await res.json().catch(() => null);
    return body;
}

export async function deleteUser(id: string) {
    const res = await apiRequest('DELETE', backendUrl(`/v1/users/${id}`), {});
    const body = await res.json().catch(() => null);
    return body;
}

export default { listUsers, createUser, updateUser, deleteUser };
